import { defaultFirmaKorrespondanceColumns } from "../../../../../config/firmaConfig";
import { FirmaKorrespondanceForm } from "../../../../../config/form/firma/firmaKorrespondanceFormConfig";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
//import ActiveIcon from "../../../../icons/ActiveIcon";
import OpenEmailIcon from "../../../../icons/OpenEmailIcon";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import DocumentModal from "../../../../Modal/modals/DocumentModal";
import { FirmaDto } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import { orderBy } from "../../../../../util/orderBy";

export default function FirmaKorrespondance({
  firma,
  invalidateData,
}: {
  firma: FirmaDto;
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "BasisWrite");
  const [firmaKorrespondanceColumns, setFirmaKorrespondanceActiveColumns] =
    useActiveColumns(
      "firma-firmakorrespondance-active-columns",
      defaultFirmaKorrespondanceColumns,
    );

  const { firmaKorrespondance } = firma;

  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "firmaKorrespondanceSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  if (firmaKorrespondance?.length === 0) {
    return <IngenRegistreringer />;
  }

  // event handlers
  function downloadHandler() {
    if (firmaKorrespondance?.length) {
      tableToXLSX(firmaKorrespondanceColumns, firmaKorrespondance, {
        fileName: `korrespondance-for-${firma.firmaNr}`,
        additionalData: {
          Firmanummer: firma.firmaNr,
        },
      });
    }
  }

  return (
    <ModalProvider>
      <ButtonDownload
        onClick={downloadHandler}
        isDisabled={!firmaKorrespondance?.length}
      />
      <TableRoot>
        <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
          <>
            {getHeaderActiveColumns(firmaKorrespondanceColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
            <th>Vis</th>
          </>
        </TableHead>
        <TableBody>
          {orderBy(
            firmaKorrespondance,
            sortBy.map((s) => s.field),
            sortBy.map((s) => s.direction),
          ).map((korrespondance, i) => {
            const editConfig = FirmaKorrespondanceForm(
              firma.id,
              korrespondance.id,
            );
            return (
              <TableRow
                key={i}
                invalidateData={invalidateData}
                editConfig={
                  canWrite
                    ? FirmaKorrespondanceForm(firma.id, korrespondance.id)
                    : undefined
                }
              >
                <>
                  {firmaKorrespondanceColumns
                    .filter((col) => col.active)
                    .map((col) => {
                      return (
                        <TD
                          key={col.field}
                          col={col}
                          rowData={korrespondance}
                        />
                      );
                    })}
                </>
                <td>
                  {editConfig.getDocument && (
                    <DocumentModal
                      getDocument={editConfig.getDocument}
                      downloadLink={editConfig.downloadLink}
                      title={
                        <>
                          <OpenEmailIcon height={18} />
                          <span className="h3">
                            {korrespondance.beskrivelse}
                          </span>
                        </>
                      }
                      buttonContents={[
                        <OpenEmailIcon key={1} />,
                        <span key={2}>Vis</span>,
                      ]}
                      contentProps={{
                        className: "c-document c-dokument--korrespondence",
                      }}
                    />
                  )}
                </td>
              </TableRow>
            );
          })}
        </TableBody>
      </TableRoot>
      <ColumnEditorModal
        defaultColumns={defaultFirmaKorrespondanceColumns}
        columns={firmaKorrespondanceColumns}
        setActiveColumns={setFirmaKorrespondanceActiveColumns}
      />
    </ModalProvider>
  );
}

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "opretDato",
  },
];
